
export default class UnsubscriptionRequestDTO {

  public email: string;

    constructor(email: string) {
    this.email = email;

  }


}
